// extracted by mini-css-extract-plugin
export var bodyContainer = "modalttc-module--body-container--4bfbf";